import { render } from "./PageHeader.vue?vue&type=template&id=8d2b95e4&scoped=true"
import script from "./PageHeader.vue?vue&type=script&lang=js"
export * from "./PageHeader.vue?vue&type=script&lang=js"

import "./PageHeader.vue?vue&type=style&index=0&id=8d2b95e4&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d2b95e4"],['__file',"src/views/index/components/PageHeader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8d2b95e4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8d2b95e4', __exports__)) {
    console.log('reload')
    api.reload('8d2b95e4', __exports__)
  }
  
  module.hot.accept("./PageHeader.vue?vue&type=template&id=8d2b95e4&scoped=true", () => {
    console.log('re-render')
    api.rerender('8d2b95e4', render)
  })

}


export default __exports__